import apiClient from './apiClient';
import { ApiResponse, PaginatedResponse, PushNotificationData, NotificationHistory } from '../../types/common';

export interface SendNotificationResponse {
  successCount: number;
  failureCount: number;
  totalCount: number;
}

export const sendPushNotification = async (
  data: PushNotificationData
): Promise<SendNotificationResponse> => {
  const response = await apiClient.post<ApiResponse<SendNotificationResponse>>(
    '/admin/notifications/push',
    data
  );

  if (response.data.status !== 200 || !response.data.data) {
    throw new Error(response.data.message || '?�시 ?�림 ?�송???�패?�습?�다.');
  }

  return response.data.data;
};

export const getNotificationHistory = async (
  filters?: { page?: number; limit?: number }
): Promise<PaginatedResponse<NotificationHistory>> => {
  const response = await apiClient.get<ApiResponse<PaginatedResponse<NotificationHistory>>>(
    '/admin/notifications/history',
    { params: filters }
  );

  if (response.data.status !== 200 || !response.data.data) {
    throw new Error(response.data.message || '?�림 ?�송 ?�력 조회???�패?�습?�다.');
  }

  return response.data.data;
};
